export default "__VITE_ASSET__upeDKZlI__"